module.exports = __webpack_public_path__ + "static/media/selectOne.862704f0.svg";